import { AbstractControl, FormControl } from '@angular/forms';
import { IpsAddressDetails } from '../ips-address/ips-address-details.interface';
import { PersonalDetailsFormField } from './personal-details-form-field.enum';

export interface IpsPersonalDetailsForm {
  [PersonalDetailsFormField.IpsAddress]: AbstractControl<{
    search: string | null;
    address: IpsAddressDetails;
  }>;
  [PersonalDetailsFormField.EmailAddress]: FormControl<string | null>;
  [PersonalDetailsFormField.FirstName]: FormControl<string | null>;
  [PersonalDetailsFormField.LastName]: FormControl<string | null>;
  [PersonalDetailsFormField.PrivacyPolicy]: FormControl<boolean | null>;
  [PersonalDetailsFormField.TelephoneNumber]: FormControl<string | null>;
}
